module.exports = __webpack_public_path__ + "img/all.7dd40be4.svg";